export const COMPONENT_TYPE = {
  list: 'i4pro-list',
  form: 'i4pro-form'
};

Object.freeze(COMPONENT_TYPE);
